module.exports = __webpack_public_path__ + "media/bootstrap-icons/clipboard-x-473be62d.svg";